import * as React from 'react'
import g from 'glamorous'
import * as moment from 'moment'

import { LoansQueryResult, Loan } from '../../components/queries/LoansQuery'
import ToPayOverlay from '../../components/ToPayOverlay'
import { Datagrid, IDefinition } from '../../components/Datagrid'
import { loan as commons } from '../../components/DatagridCommons'
import { moneyFormat } from '../../utils/format'

type UserLoansTableProps = {
  loans: LoansQueryResult['loans']
}

const TrNoHover = g.tr(() => ({
  border: '1px solid white',
  ':hover': {
    backgroundColor: 'white !important'
  }
}))

const definition: IDefinition<Loan> = {
  columns: [
    commons.columns.date,
    commons.columns.debtors,
    commons.columns.interval,
    commons.columns.description,
    commons.columns.interest,
    commons.columns.loanedAmount,
    commons.columns.toPay,
    commons.columns.detailAction
  ],
  idGetter: data => data.id,
  defaultSort: 'date'
}

const UserLoansTable: React.SFC<UserLoansTableProps> = ({ loans }) => (
  <Datagrid definition={definition} data={loans}>
    {(data) => (
      <TrNoHover>
        <td colSpan={5} style={{ border: '0px' }} />
        <td style={{ border: '0px', textAlign: 'right' }}>
          Celk. jistina:{' '}
          {moneyFormat(
            data.reduce((sum, loan) => sum + (loan.state.loanedAmount || 0), 0)
          )}
        </td>
        <td style={{ border: '0px', textAlign: 'right' }}>
          <ToPayOverlay label="Celk. půjčeno" loans={data} date={moment()} />
        </td>
        <td style={{ border: '0px' }} />
      </TrNoHover>
    )}
  </Datagrid>
)

export default UserLoansTable



// WEBPACK FOOTER //
// ./src/screens/dashboard/UserLoansTable.tsx